// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GnWY","field":"styles_field__1-vYo","fieldCol":"styles_fieldCol__33H2Q","diffCol":"styles_diffCol__2IwPx","diff":"styles_diff__34dYP"};